module.exports = __webpack_public_path__ + "assets/images/ecf0fa95234bfdec8550923ab045a6d2.png";